<template>
  <div style="height:600px; overflow: scroll">
    <b-row>
      <b-col cols="0" md="2"></b-col>
      <b-col cols="12" md="8">
        <b-input-group class="align-content-center">
          <template #prepend>
            <b-input-group-text>
              What's the Sign? ™
            </b-input-group-text>
          </template>
          <b-form-input :disabled="isSending" name="search_input" v-model="form.search"
                        @keydown.enter.native="searchDictionary(1)"
                        type="text" aria-label="Type to search signs" aria-describedby="input-live-search"></b-form-input>
          <b-input-group-append>
            <b-button block variant="success" @click="searchDictionary(1)">Search
              <b-spinner v-if="isSending" class="m-1" label="Spinning" small/>
            </b-button>
          </b-input-group-append>
        </b-input-group>
        <div class="mt-2 mb-4 small" id="input-live-search">
          Type in a word or a specific unit (i.e. "Unit 3.1") for a list of signs.
        </div>
      </b-col>
      <b-col cols="0" md="2"></b-col>
    </b-row>
    <b-row v-if="total">
      <b-col cols="0" md="2"></b-col>
      <b-col cols="12" md="8">
        <div class="my-1">{{terms.length}} results</div>
        <b-list-group v-if="terms.length">
          <b-list-group-item button v-for="(term, index) in terms" :key="term.id"
                             v-html="term.title"
                             @click="showSigns(index)"></b-list-group-item>
        </b-list-group>
        <b-modal modal-class="modal-player" header-bg-variant="dark" ok-only
                 header-text-variant="light" v-model="showModal" id="modal-center"
                 scrollable :title="selected_term.title">
          <p class="my-4" v-html="selected_term.content"></p>
          <template #modal-footer>
            <div class="w-100">
              <p class="float-left">
                <b-button v-if="selected_index !== 0" variant="outline-primary" size="sm" class="mr-2" @click="showSigns(selected_index-1)">
                  Back
                </b-button>

                <b-button v-if="terms.length !== (selected_index + 1)" variant="outline-primary" size="sm" class="" @click="showSigns(selected_index+1)">
                  Next
                </b-button>

              </p>
              <b-button
                  variant="primary"
                  size="sm"
                  class="float-right"
                  @click="showModal=false"
              >
                Close
              </b-button>
            </div>
          </template>
        </b-modal>
      </b-col>
      <b-col cols="0" md="2"></b-col>
    </b-row>
    <b-row v-else-if="total === 0">
      <b-col cols="0" md="2"></b-col>
      <b-col cols="12" md="8">
        <p>
          Sorry, no signs found. Try another word or unit?
        </p>
      </b-col>
      <b-col cols="0" md="2"></b-col>
    </b-row>
    <b-row v-else-if="search_error">
      <b-col cols="0" md="2"></b-col>
      <b-col cols="12" md="8">
        <b-alert show variant="warning">
          {{ search_error }} Please try your search again, or contact us at hello@truewayasl.com.
        </b-alert>
      </b-col>
      <b-col cols="0" md="2"></b-col>
    </b-row>
    <b-row v-else>
      <b-col cols="0" md="2"></b-col>
      <b-col cols="12" md="8">
        <div class="text-center">
          <b-spinner variant="secondary" v-if="isSending" class="m-5" label="Spinning"/>
        </div>
      </b-col>
      <b-col cols="0" md="2"></b-col>
    </b-row>
  </div>
</template>

<script>
import {searchSigns} from "..//utils/lti-api"
import {getErrorMessage} from "@/utils/error-messages"
import {initBeacon, reportErrorToBeacon} from "@/utils/beacon"

export default {
  name: 'dictionary',
  data() {
    return {
      selected_term: {
        title: null,
        content: null
      },
      selected_index: null,
      showModal: false,
      form: {
        search: '',
      },
      terms: [],
      total: null,
      search_error: null,
      isSending: false
    }
  },

  methods: {
    showSigns(index) {
      this.selected_index = index
      this.selected_term = this.terms[index]
      this.showModal = true
    },
    async searchDictionary() {
      try {
        this.form.search = this.form.search.replace(/[“”]/g, '"')
        console.log('Searching', this.form.search)
        this.total = null
        this.search_error = null
        this.isSending = true
        this.terms = []
        const response = await searchSigns(this.form.search)
        this.terms = response.data.terms
        this.total = this.terms.length
      } catch (error) {
        // Guard error.response — a network failure has none, and dereferencing it
        // here used to throw inside the catch (silent, spinner stuck).
        if (error.response && error.response.status === 404) {
          this.total = 0
        } else {
          // Surface the failure (a silent empty result reads as "no signs found")
          // and arm Beacon so "contact us" carries the underlying error.
          this.search_error = getErrorMessage(error)
          initBeacon()
          reportErrorToBeacon(error, 'Dictionary Search Error',
            { 'Flow': 'Dictionary', 'Search': this.form.search })
        }
      }
      this.isSending = false
    }
  },

  mounted() {
  }
}
</script>

<style>
.modal-player .modal-dialog {
  max-width: 555px;
}
.modal-body {
  padding: 0 1rem !important;
}
</style>